import React, {
    Component,
    PureComponent
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { actionTypes } from '~/constants';
import moment from 'moment';

import fetch from '~/utils/fetch';
import awsconfig from '~/awsconfig';

import Icon from '@material-ui/core/Icon';

import ButtonBase from "@material-ui/core/ButtonBase";



class Container extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null,
        }
    }

    async componentDidMount() {
        console.log(`WARN: Redirecting from Dashboard to Departments.`);
        this.props.history.push(`/app/departments`);
    }

    render() {
        console.log(this.props);


        return (
            <React.Fragment> {/* parent is div.page */}
                <div className="page-nav">
                    <div className="breadcrumb">
                        <h1>Dashboard</h1>
                    </div>
                </div>
                <div className="card card-table">
                </div>
            </React.Fragment>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            // reports: state.reports,
            // users: state.users,
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    },
    null,
    {pure: false}
)(Container);